import { BaseCurrencyInput, Input, Label, Radio, Select } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";

const periods = [
  { label: "Dias", value: "day" },
  { label: "Meses", value: "month" },
  { label: "Anos", value: "year" },
];

export const TimeForm = ({ range, onChange }) => {
  const [type, setType] = useState(range?.type || null);
  const [period, setPeriod] = useState(range?.period || "day");
  const [min, setMin] = useState(range?.min || null);
  const [max, setMax] = useState(range?.max || null);

  const getFreshNode = () => {
    return { type, period, min, max };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [type, period, min, max]);

  const changeType = (type) => {
    setType((oldType) => {
      if (oldType != type) {
        setPeriod("day");
        setMin(null);
        setMax(null);
      }
      return type;
    });
  };

  return (
    <>
      <Radio
        text="Todo o período"
        family="time"
        value={null}
        checked={type}
        className="mt-15 mb-15"
        readOnly
      />

      <Radio
        text="Nos últimos"
        family="time"
        value="in_last"
        checked={type}
        className="mb-15"
        readOnly
      />

      <Radio
        text="A mais de"
        family="time"
        value="more_than"
        checked={type}
        className="mb-15"
        readOnly
      />

      <Radio
        text="Período personalizado"
        family="time"
        value="range"
        checked={type}
        readOnly
      />

      {["in_last", "more_than"].includes(type) && (
        <>
          <div className="d-flex gap-5 mt-15">
            <div className={styles.minMax}>{min || "0"}</div>
            <div className={styles.value}>
              {periods.find((p) => p.value === period)?.label}
            </div>
          </div>
        </>
      )}

      {type === "range" && (
        <>
          <div className="d-flex gap-10 mt-15">
            <p className={styles.value}>{min}</p>
            <p className={styles.value}>{max}</p>
          </div>
        </>
      )}
    </>
  );
};
